import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from '../../components/FieldJobForms/FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import _, { forEach } from 'lodash';
import {connect} from "react-redux";
import Downshift from 'downshift';
import Modal from 'react-modal';

const WorkOrderForm = class extends Component{
    workOrderId = this.props.match.params.id;
    source = axios.CancelToken.source();
    pickfields = [];
    reqFields = ['Customer_verbally_approved_layout__c'];

    postRequestFields = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Work_Types__c",
            "Clocked_Start__c",
            "Clocked_End__c",

            "Field_Team_Pay_IDs__c",
            "Assigned_Field_Team__c",
            "Assigned_Field_Team__r.Subcontractor__c",
            "Assigned_Field_Team__r.Name",
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Name",
            "Assigned_Field_Team__r.Tech_1__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_2__c",
            "Assigned_Field_Team__r.Tech_2__r.Name",
            "Assigned_Field_Team__r.Tech_2__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_3__c",
            "Assigned_Field_Team__r.Tech_3__r.Name",
            "Assigned_Field_Team__r.Tech_3__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_4__c",
            "Assigned_Field_Team__r.Tech_4__r.Name",
            "Assigned_Field_Team__r.Tech_4__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_5__c",
            "Assigned_Field_Team__r.Tech_5__r.Name",
            "Assigned_Field_Team__r.Tech_5__r.Payroll_ID__c",
            "Assigned_Field_Team_2__c",
            "Assigned_Field_Team_2__r.Tech_1__c",
            "Assigned_Field_Team_2__r.Tech_1__r.Name",
            "Assigned_Field_Team_2__r.Tech_1__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_2__c",
            "Assigned_Field_Team_2__r.Tech_2__r.Name",
            "Assigned_Field_Team_2__r.Tech_2__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_3__c",
            "Assigned_Field_Team_2__r.Tech_3__r.Name",
            "Assigned_Field_Team_2__r.Tech_3__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_4__c",
            "Assigned_Field_Team_2__r.Tech_4__r.Name",
            "Assigned_Field_Team_2__r.Tech_4__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_5__c",
            "Assigned_Field_Team_2__r.Tech_5__r.Name",
            "Assigned_Field_Team_2__r.Tech_5__r.Payroll_ID__c",

            "Opportunity__c",
            "Opportunity__r.Electrical_Work__c",
            "Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c",
            "Opportunity__r.Battery_Type__c",
            "Opportunity__r.Battery_Type__r.Name",

            "Case__c",
            "Case__r.Description",
            "Case__r.RecordTypeId",
            "Case__r.ToDoListValues__c",

            "Meter_release_inspection_outcome__c",
            "Were_there_any_accidents_or_injuries__c",
            "Was_the_final_walkthrough_completed__c",
            "Outcome__c",
            "Failed_Inspection_Reason_s__c",
            "Failed_Inspection_Subreasons__c",
            "Was_the_job_card_uploaded__c",
            "What_was_the_cause_of_the_issue__c",
            "Was_the_issue_100_resolved__c",
            "What_solution_was_implemented__c",
            "Was_the_Safe_Harbor_equipment_delivered__c",
            "Is_the_job_ready_for_final_inspection__c",
            "Is_follow_up_needed__c",
            "Cancellation_Type__c",
            "What_was_the_reason_for_canceling__c",
            "Reason_for_not_completing_work__c",
            "Did_you_have_all_necessary_equipment__c",
            "What_work_is_remaining__c",
            "Estimated_time_needed_to_finish_job__c",
            "Are_all_required_job_photos_uploaded__c",
            "Was_the_customer_home__c",
            "Was_the_customer_informed_of_job_status__c",
            "Did_the_customer_sign_the_NEM_form__c",
            "Can_the_customer_turn_on_the_system__c",
            "Did_the_customer_approve_the_plans__c",
            "Is_a_design_revision_needed__c",
            "Is_a_permit_revision_needed__c",
            "CAD_Errors__c",
            "Was_the_roof_work_completed__c",
            "X3_Foot_Fire_Clearance_Met__c",
            "Are_the_panels_square_and_level__c",
            "Are_the_rain_gutters_clean_of_debris__c",
            "Tile_replacement_flashings_secured__c",
            "Are_there_any_broken_tiles__c",
            "Number_of_Broken_Tiles__c",
            "Were_all_the_broken_tiles_fixed__c",
            "How_many_tiles_are_still_needed__c",
            "Was_the_roof_damaged_by_the_install__c",
            "Describe_the_roof_damage__c",
            "Was_trash_left_at_the_job_site__c",
            "Did_installers_leave_work_incomplete__c",
            "Is_a_roof_service_call_needed__c",
            "Was_the_install_ready_for_inspection__c",
            "Is_the_electrical_work_clean__c",
            "What_electrical_work_needs_to_be_fixed__c",
            "Are_there_any_workmanship_issues__c",
            "Able_to_Fix_On_Site__c",
            "Job_Notes__c",
            "Is_the_electrical_work_complete__c",
            "Was_the_MPU_completed__c",
            "Was_there_a_utility_inspection__c",
            "Was_power_restored_to_the_home__c",
            "Why_wasn_t_power_restored_to_the_home__c",
            "Is_the_Battery_Install_Complete__c",
            "Why_hasn_t_the_battery_been_installed__c",
            "X120_Rule_Is_the_PCS_feature_set_up__c",
            "Did_the_customer_confirm_the_circuits__c",
            "Was_battery_backup_tested_for_10_min__c",
            "Customer_registered_while_commissioning__c",
            "Is_the_customer_registered_with_Tesla__c",
            "Gateway_Serial_Number__c",
            "Was_the_solar_tied_in__c",
            "Monitoring_fully_set_up_photo_uploaded__c",
            "Are_all_panels_paired__c",
            "Why_wasn_t_the_system_paired__c",
            "Were_the_CTs_verified_as_correct__c",
            "Does_the_system_appear_functional__c",
            "Does_the_system_have_S_OK__c",
            "Inverter_optimizer_needs_to_be_RMAed__c",
            "Case_RMA_Number__c",
            "What_is_the_old_serial_number__c",
            "What_is_the_new_serial_number__c",
            "Was_the_derate_completed__c",
            "Why_wasn_t_the_derate_completed__c",
            "Was_the_new_subpanel_installed__c",
            "Was_the_SPAN_panel_installed__c",
            "Was_the_subpanel_upgraded__c",
            "Why_wasn_t_the_subpanel_completed__c",
            "Is_a_trench_needed__c",
            "Was_the_trench_completed__c",
            "Was_sand_required_but_not_filled_in__c",
            "What_was_the_trench_inspection_outcome__c",
            "Was_the_breaker_relocation_completed__c",
            "Was_the_220V_outlet_installed__c",
            "Was_the_EV_charger_installed__c",
            "Was_the_transfer_switch_completed__c",
            "What_is_the_type_of_transfer_switch__c",
            "Was_other_electrical_work_completed__c",
            "Is_internet_access_available__c",
            "Is_labeling_completed__c",
            "Was_the_placard_installed__c",
            "Is_the_conduit_painted__c",
            "Why_wasn_t_the_conduit_painted__c",
            "Is_there_any_damage_to_siding_stucco__c",
            "Does_the_AHJ_require_a_lathe_inspection__c",
            "Upgrade_ready_for_final_inspection__c",
            "Electrical_Notes__c",
            "Customer_comments__c",
            "Digital_Inspection_Result__c",
            "What_work_was_partially_completed__c",
            "What_work_was_fully_completed__c",
            "Are_there_any_unpermitted_structures__c",
            "Structure_Levels__c",
            "Attic_Structure__c",
            "Ceiling_Type__c",
            "Survey_Type__c",
            "Rafters__c",
            "Is_There_Existing_Solar__c",
            "What_is_the_rafter_spacing__c",
            "What_is_the_roof_tilt__c",
            "What_is_the_roof_type__c",
            "Are_the_tiles_fragile_or_lightweight__c",
            "What_is_the_roof_condition__c",
            "Is_the_roof_mossy_or_slippery__c",
            "Ceiling_type_for_Structure_2__c",
            "Attic_structure_type_for_Structure_2__c",
            "What_are_the_rafters_in_Structure_2__c",
            "Rafter_spacing_for_Structure_2__c",
            "Structure_2_tiles_fragile_lightweight__c",
            "Broken_tile_count_for_Structure_2__c",
            "Roof_condition_for_Structure_2__c",
            "Roof_mossy_slippery_for_Structure_2__c",
            "What_is_the_roof_tilt_for_Structure_2__c",
            "What_is_the_roof_type_for_Structure_2__c",
            "Is_a_third_structure_being_surveyed__c",
            "What_waste_management_method_was_used__c",
            "What_is_the_siding_type__c",
            "What_is_the_utility_feed__c",
            "Meter_Number__c",
            "Are_there_multiple_service_meters__c",
            "MSP_Mounting__c",
            "Grounding__c",
            "Gas_Riser_Horizontal_Dist_in__c",
            "Gas_Regulator_Radial_Dist_in__c",
            "Drone_Survey__c",
            "MSP_Condition__c",
            "MSP_Brand__c",
            "MSP_Feed__c",
            "Main_Breaker_Rating__c",
            "MSP_Busbar_Rating__c",
            "Are_any_panels_missing_a_dead_front__c",
            "Existing_PV_Breaker_Size__c",
            "Are_there_multiple_existing_inverters__c",
            "Existing_Inverter_Model_Number__c",
            "Existing_ACD__c",
            "Multiple_existing_solar_systems__c",
            "What_is_the_trench_distance_feet__c",
            "What_materials_are_in_the_trench_path__c",
            "Existing_Array_Tilt__c",
            "Existing_Array_Azimuth__c",
            "Existing_module_number__c",
            "How_many_existing_modules_are_there__c",
            "Jobsite_Photos__c",
            "Is_there_an_existing_EV_charger__c",
            "What_is_the_EV_charger_breaker_amperage__c",
            "Is_the_EV_charger_permitted__c",
            "Existing_generator_or_transfer_switch__c",
            "What_is_the_generator_breaker_amperage__c",
            "Is_the_Generator_permitted__c",
            "What_is_the_RSS_reason__c",
            "Is_plywood_present__c",
            "Is_a_special_panel_present__c",
            "Was_the_TRX_shared__c",
            "How_many_subpanels_are_there__c",
            "X3_Phase__c",
            "System_A_Existing_Battery_Mfr__c",
            "System_B_Existing_Battery_Mfr__c",
            "Ground_Rod_811_Marking__c",
            "Ground_rod_811_marking_notes__c",
            "What_is_the_tile_weight__c",
            "Is_this_a_manufactured_home__c",
            "Were_HUD_label_and_decal_photos_taken__c",
            "Largest_Breaker__c",
            "AC_Unit__c",
            "Largest_AC_Unit_Breaker_Size__c",
            "LRA1__c",
            "LRA2__c",
            "LRA3__c",
            "What_is_needed_from_this_RSS__c",
            "Duration__c",
            "Job_Overview__c",
            "Job_Overview__r.Install_Work_Duration_hours__c",
            "Job_Overview__r.Install_Work_Duration_Completed_hours__c",
            "Job_Overview__r.Backup_Work_Duration_hours__c",
            "Job_Overview__r.Backup_Work_Duration_Completed_hours__c",
            "Job_Overview__r.TOU_Work_Duration_hours__c",
            "Job_Overview__r.TOU_Work_Duration_Completed_hours__c",
            "Job_Overview__r.MPU_Work_Duration_hours__c",
            "Job_Overview__r.MPU_Work_Duration_Completed_hours__c",
            "Job_Overview__r.Subpanel_Upgrade_Work_Duration_hours__c",
            "Job_Overview__r.Subpanel_Upgrade_Duration_Completed_hrs__c",
            "Job_Overview__r.New_Subpanel_Work_Duration_hours__c",
            "Job_Overview__r.New_Subpanel_Duration_Completed_hours__c",
            "Job_Overview__r.Derate_Work_Duration_hours__c",
            "Job_Overview__r.Derate_Work_Duration_Completed_hours__c",
            "Job_Overview__r.Trench_Work_Duration_hours__c",
            "Job_Overview__r.Trench_Work_Duration_Completed_hours__c",
            "Job_Overview__r.Service_Work_Duration_hours__c",
            "Job_Overview__r.Service_Work_Duration_Completed_hours__c",
            "Job_Overview__r.Trench_Inspection_Work_Duration_hours__c",
            "Job_Overview__r.Trench_Inspection_Duration_Completed_hrs__c",
            "Job_Overview__r.Misc_Electrical_Work_Duration_hours__c",
            "Job_Overview__r.Misc_Electrical_Duration_Completed_hrs__c"
        ],
        "where": {
            "Id": this.workOrderId
        }
    };

    state = {
        isEditing: false,
        shouldShowAlert: false,
        showCancel: false,
        disableSave: false,

        workOrder: {},

        // name (string) - visible label
        // apiName (string) - Salesforce API name of the field.
        // type (string. "picklist", "multiPicklist", "yesNo", "textarea", "num", "text") - type of the field.
        // showWT (boolean) - set to false if field is shown based on work types. Set to true if field should always be shown.
        // wt (array of strings) - work types that the field should be shown for.
        // cField (string) - Salesforce API name of the field to compare the value of.
        // cValue (string) - value to compare the value of the field to. It checks if the cField contains the cValue. If cField does contain, the field will be shown.
        // showTooltip (boolean) - set to true if a tooltip should be shown for the field.
        // tooltipInfo (string) - tooltip information to show for the field.
        mappedFields: [
            {name:"What was partially completed?",apiName:'What_work_was_partially_completed__c',type:'picklist',showWT:false, cField:'Outcome__c',cValue:'Partial Completion',
                wt:['Site Survey']
            },
            {name:"What was fully completed?",apiName:'What_work_was_fully_completed__c',type:'picklist',showWT:false, cField:'Outcome__c',cValue:'Full Completion',
                wt:['Site Survey']
            },
            {name:"Any unpermitted structures?*",apiName:'Are_there_any_unpermitted_structures__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Digital Inspection Result",apiName:'Digital_Inspection_Result__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },

            {name:"Were there any accidents or injuries?",apiName:'Were_there_any_accidents_or_injuries__c',type:'yesNo',showWT:true},

            {name:"Was the final walkthrough completed?",apiName:'Was_the_final_walkthrough_completed__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },

            {name:"Failed Inspection Reason(s)",apiName:'Failed_Inspection_Reason_s__c',type:'multiPicklist',showWT:false,cField:'Outcome__c',cValue:'Fail',
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was the job card uploaded?",apiName:'Was_the_job_card_uploaded__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"What was the cause of the issue?",apiName:'What_was_the_cause_of_the_issue__c',type:'textarea',showWT:false,
                wt:['Service']
            },
            {name:"Was the issue 100% resolved?",apiName:'Was_the_issue_100_resolved__c',type:'yesNo',showWT:false,
                wt:['Service']
            },
            {name:"What solution was implemented?",apiName:'What_solution_was_implemented__c',type:'textarea',showWT:false,
                wt:['Service']
            },
            {name:"Was the Safe Harbor equipment delivered?",apiName:'Was_the_Safe_Harbor_equipment_delivered__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery']
            },
            {name:"Is the job ready for final inspection?",apiName:'Is_the_job_ready_for_final_inspection__c',type:'picklist',showWT:false,showTooltip:true,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench']
            },
            {name:"Meter Release Inspection Outcome",apiName:'Meter_release_inspection_outcome__c',type:'picklist',showWT:false,
                wt:['MPU']
            },
            {name:"Is follow-up needed?",apiName:'Is_follow_up_needed__c',type:'yesNo',showWT:true},
            {name:"Cancellation Type",apiName:'Cancellation_Type__c',type:'picklist',showWT:true},
            {name:"What was the reason for canceling?",apiName:'What_was_the_reason_for_canceling__c',type:'picklist',showWT:true,cField:'Outcome__c',cValue:'Canceled'},

            {name:"Reason for not completing work?",apiName:'Reason_for_not_completing_work__c',type:'picklist',showWT:false,cField:'Outcome__c',cValue:'Partial Completion',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service']
            },
            {name:"Did you have all necessary equipment?",apiName:'Did_you_have_all_necessary_equipment__c',type:'picklist',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service']
            },
            {name:"What work is remaining?",apiName:'What_work_is_remaining__c',type:'multiPicklist',showWT:false,cField:'Outcome__c',cValue:'Partial Completion',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Estimated time needed to finish job?",apiName:'Estimated_time_needed_to_finish_job__c',type:'picklist',showWT:false,cField:'Outcome__c',cValue:'Partial Completion',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service']
            },

            {name:"Are all required job photos uploaded?",apiName:'Are_all_required_job_photos_uploaded__c',type:'yesNo',showWT:true},
            {name:"Was the customer home?",apiName:'Was_the_customer_home__c',type:'yesNo',showWT:true},

            {name:"Was the customer informed of job status?",apiName:'Was_the_customer_informed_of_job_status__c',type:'picklist',showWT:false,cField:'Was_the_customer_home__c',cValue:'Yes',showTooltip:true,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Did the customer sign the NEM form?",apiName:'Did_the_customer_sign_the_NEM_form__c',type:'yesNo',showWT:false,cField:'Was_the_customer_home__c',cValue:'Yes',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Can the customer turn on the system?",apiName:'Can_the_customer_turn_on_the_system__c',type:'picklist',showWT:false,cField:'Was_the_customer_home__c',cValue:'Yes',
                wt:['Install','Backup Battery','TOU Battery','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },

            {name:"Customer Comments",apiName:'Customer_comments__c',type:'textarea',showWT:true,cField:'Was_the_customer_home__c',cValue:'Yes'},

            {name:"Did the customer approve the plans?",apiName:'Did_the_customer_approve_the_plans__c',type:'picklist',showWT:false,cField:'Was_the_customer_home__c',cValue:'Yes',showTooltip:true,
                wt:['Install']
            },
            {name:"Drone Survey",apiName:'Drone_Survey__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Is internet access available?",apiName:'Is_internet_access_available__c',type:'multiPicklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is needed from the RSS?",apiName:'What_is_needed_from_this_RSS__c',type:'text',showWT:false, cField:'Outcome__c', cValue:'Partial Completion',
                wt:['Site Survey']
            },
            {name:"Is this a manufactured home?",apiName:'Is_this_a_manufactured_home__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Were HUD label and decal photos taken?",apiName:'Were_HUD_label_and_decal_photos_taken__c',type:'yesNo',showWT:false,  cField:'Is_this_a_manufactured_home__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Structure Levels",apiName:'Structure_Levels__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"Ceiling Type",apiName:'Ceiling_Type__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Attic Structure",apiName:'Attic_Structure__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Is plywood present?",apiName:'Is_plywood_present__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Existing Array Tilt",apiName:'Existing_Array_Tilt__c',type:'num',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Existing Array Azimuth",apiName:'Existing_Array_Azimuth__c',type:'num',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Existing Module Make and Model Number",apiName:'Existing_module_number__c',type:'text',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"How many existing modules are there?",apiName:'How_many_existing_modules_are_there__c',type:'num',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Rafters",apiName:'Rafters__c',type:'text',showWT:false,
                wt:['Site Survey']
            },
            {name:"Rafter Spacing (approx inches)",apiName:'What_is_the_rafter_spacing__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the roof tilt?",apiName:'What_is_the_roof_tilt__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the roof type?",apiName:'What_is_the_roof_type__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the tile weight?",apiName:'What_is_the_tile_weight__c',type:'text',showWT:false,
                wt:['Site Survey']
            },
            {name:"Fragile or lightweight tile?",apiName:'Are_the_tiles_fragile_or_lightweight__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"How many tiles did you break?",apiName:'Number_of_Broken_Tiles__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the roof condition?",apiName:'What_is_the_roof_condition__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Roof mossy or slippery?",apiName:'Is_the_roof_mossy_or_slippery__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Structure #2 Ceiling Type",apiName:'Ceiling_type_for_Structure_2__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Attic Structure",apiName:'Attic_structure_type_for_Structure_2__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Rafters",apiName:'What_are_the_rafters_in_Structure_2__c',type:'text',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Rafter Spacing",apiName:'Rafter_spacing_for_Structure_2__c',type:'num',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Roof Tilt",apiName:'What_is_the_roof_tilt_for_Structure_2__c',type:'num',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Roof Type",apiName:'What_is_the_roof_type_for_Structure_2__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Fragile or Lightweight Tile",apiName:'Structure_2_tiles_fragile_lightweight__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 How many tiles did you break?",apiName:'Broken_tile_count_for_Structure_2__c',type:'num',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Roof Condition",apiName:'Roof_condition_for_Structure_2__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Structure #2 Roof Mossy or Slippery?",apiName:'Roof_mossy_slippery_for_Structure_2__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Third structure being surveyed?",apiName:'Is_a_third_structure_being_surveyed__c',type:'yesNo',showWT:false, cField:'Survey_Type__c', cValue:'Additional Structure',
                wt:['Site Survey']
            },
            {name:"Waste Management Method",apiName:'What_waste_management_method_was_used__c',type:'picklist',showWT:false, cField:'Survey_Type__c', cValue:'Ground Mount',
                wt:['Site Survey']
            },
            {name:"What is the siding type? (at MSP)",apiName:'What_is_the_siding_type__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Are there multiple service meters?",apiName:'Are_there_multiple_service_meters__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Meter Number*",apiName:'Meter_Number__c',type:'text',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the utility feed?",apiName:'What_is_the_utility_feed__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"MSP Mounting",apiName:'MSP_Mounting__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Grounding",apiName:'Grounding__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Ground Rod 811 Marking",apiName:'Ground_Rod_811_Marking__c',type:'picklist',showWT:false, showWT:false, cField:'Grounding__c', cValue:'Ground Rod',
                wt:['Site Survey']
            },
            {name:"Ground Rod 811 Marking Notes",apiName:'Ground_rod_811_marking_notes__c',type:'textarea',showWT:false, showWT:false, cField:'Grounding__c', cValue:'Ground Rod',
                wt:['Site Survey']
            },
            {name:"What is the gas riser horizontal distance (in)?",apiName:'Gas_Riser_Horizontal_Dist_in__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the gas regulator radial distance?",apiName:'Gas_Regulator_Radial_Dist_in__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"MSP Condition",apiName:'MSP_Condition__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"MSP Brand",apiName:'MSP_Brand__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"MSP Feed",apiName:'MSP_Feed__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Is a special panel present?",apiName:'Is_a_special_panel_present__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Main Breaker Rating",apiName:'Main_Breaker_Rating__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"MSP Busbar Rating",apiName:'MSP_Busbar_Rating__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"Are any panels missing a dead front?",apiName:'Are_any_panels_missing_a_dead_front__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Was the TRX shared?",apiName:'Was_the_TRX_shared__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"How many subpanels are there?",apiName:'How_many_subpanels_are_there__c',type:'num',showWT:false,
                wt:['Site Survey']
            },
            {name:"3 Phase?",apiName:'X3_Phase__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Is there existing solar?",apiName:'Is_There_Existing_Solar__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"Existing PV Breaker Size",apiName:'Existing_PV_Breaker_Size__c',type:'picklist',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Are there multiple existing inverters?",apiName:'Are_there_multiple_existing_inverters__c',type:'yesNo',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Existing Inverter Make and Model Number",apiName:'Existing_Inverter_Model_Number__c',type:'text',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Existing ACD",apiName:'Existing_ACD__c',type:'picklist',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"System A existing battery manufacturer",apiName:'System_A_Existing_Battery_Mfr__c',type:'picklist',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Multiple Existing Solar Systems",apiName:'Multiple_existing_solar_systems__c',type:'yesNo',showWT:false, cField:'Is_There_Existing_Solar__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"System B Battery",apiName:'System_B_Existing_Battery_Mfr__c',type:'picklist',showWT:false, cField:'Multiple_existing_solar_systems__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Is a trench needed?",apiName:'Is_a_trench_needed__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the trench distance (approx feet)?",apiName:'What_is_the_trench_distance_feet__c',type:'num',showWT:false, cField:'Is_a_trench_needed__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"What materials are in the trench path?",apiName:'What_materials_are_in_the_trench_path__c',type:'picklist',showWT:false, cField:'Is_a_trench_needed__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Is there an existing EV charger?",apiName:'Is_there_an_existing_EV_charger__c',type:'yesNo',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the Amperage of EV Charger Breaker?",apiName:'What_is_the_EV_charger_breaker_amperage__c',type:'text',showWT:false, cField:'Is_there_an_existing_EV_charger__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Is the EV charger permitted?",apiName:'Is_the_EV_charger_permitted__c',type:'yesNo',showWT:false, cField:'Is_there_an_existing_EV_charger__c', cValue:'Yes',
                wt:['Site Survey']
            },
            {name:"Existing generator or transfer switch?",apiName:'Existing_generator_or_transfer_switch__c',type:'picklist',showWT:false,
                wt:['Site Survey']
            },
            {name:"What is the Amperage of Generator Breaker?",apiName:'What_is_the_generator_breaker_amperage__c',type:'text',showWT:false, cField:'Existing_generator_or_transfer_switch__c', cValue:'Generator',
                wt:['Site Survey']
            },
            {name:"Is the Generator permitted?",apiName:'Is_the_Generator_permitted__c',type:'yesNo',showWT:false, cField:'Existing_generator_or_transfer_switch__c', cValue:'Generator',
                wt:['Site Survey']
            },
            {name:"Largest Breaker",apiName:'Largest_Breaker__c',type:'num',showWT:false, cField: 'Survey_Type__c', cValue: 'Battery',
                wt:['Site Survey']
            },
            {name:"AC Unit",apiName:'AC_Unit__c',type:'yesNo',showWT:false, cField: 'Survey_Type__c', cValue: 'Battery',
                wt:['Site Survey']
            },
            {name:"Largest AC Unit Breaker Size",apiName:'Largest_AC_Unit_Breaker_Size__c',type:'num',showWT:false, cField: 'AC_Unit__c', cValue: 'Yes',
                wt:['Site Survey']
            },
            {name:"LRA1",apiName:'LRA1__c',type:'num',showWT:false, cField: 'Survey_Type__c', cValue: 'Battery',
                wt:['Site Survey']
            },
            {name:"LRA2",apiName:'LRA2__c',type:'num',showWT:false, cField: 'Survey_Type__c', cValue: 'Battery',
                wt:['Site Survey']
            },
            {name:"LRA3",apiName:'LRA3__c',type:'num',showWT:false, cField: 'Survey_Type__c', cValue: 'Battery',
                wt:['Site Survey']
            },
            {name:"Jobsite Photos",apiName:'Jobsite_Photos__c',type:'text',showWT:false,
                wt:['Site Survey']
            },
            {name:"Is a design revision needed?",apiName:'Is_a_design_revision_needed__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench']
            },
            {name:"CAD Errors",apiName:'CAD_Errors__c',type:'picklist',showWT:false,cField:'Is_a_design_revision_needed__c',cValue:'Yes',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench']
            },
            {name:"Is a permit revision needed?",apiName:'Is_a_permit_revision_needed__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was the roof work completed?",apiName:'Was_the_roof_work_completed__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Install']
            },
            {name:"3-Foot Fire Clearance Met?",apiName:'X3_Foot_Fire_Clearance_Met__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Install']
            },
            {name:"Are the panels square and level?",apiName:'Are_the_panels_square_and_level__c',type:'yesNo',showWT:false,
                wt:['Install']
            },
            {name:"Are the rain gutters clean of debris?",apiName:'Are_the_rain_gutters_clean_of_debris__c',type:'picklist',showWT:false,
                wt:['Install']
            },
            {name:"Tile replacement flashings secured?",apiName:'Tile_replacement_flashings_secured__c',type:'yesNo',showWT:false,
                wt:['Install']
            },
            {name:"Are there any broken tiles?",apiName:'Are_there_any_broken_tiles__c',type:'yesNo',showWT:false,
                wt:['Install','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Number of broken tiles",apiName:'Number_of_Broken_Tiles__c',type:'num',showWT:false,cField:'Are_there_any_broken_tiles__c',cValue:'Yes',
                wt:['Install','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Were all the broken tiles fixed?",apiName:'Were_all_the_broken_tiles_fixed__c',type:'yesNo',showWT:false,cField:'Are_there_any_broken_tiles__c',cValue:'Yes',
                wt:['Install','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"How many tiles are still needed?",apiName:'How_many_tiles_are_still_needed__c',type:'num',showWT:false,cField:'Were_all_the_broken_tiles_fixed__c',cValue:'No',
                wt:['Install','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was the roof damaged by the install?",apiName:'Was_the_roof_damaged_by_the_install__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Describe the roof damage (if any)",apiName:'Describe_the_roof_damage__c',type:'textarea',showWT:false,
                wt:['Install','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was trash left at the job site?",apiName:'Was_trash_left_at_the_job_site__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Did installers leave work incomplete?",apiName:'Did_installers_leave_work_incomplete__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Is a roof service call needed?",apiName:'Is_a_roof_service_call_needed__c',type:'picklist',showWT:false,cField:'Did_installers_leave_work_incomplete__c',cValue:'Yes',
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was the install ready for inspection?",apiName:'Was_the_install_ready_for_inspection__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Is the electrical work clean?",apiName:'Is_the_electrical_work_clean__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"What electrical work needs to be fixed?",apiName:'What_electrical_work_needs_to_be_fixed__c',type:'multiPicklist',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Are there any workmanship issues?",apiName:'Are_there_any_workmanship_issues__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Able to fix on-site?",apiName:'Able_to_Fix_On_Site__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Is the electrical work complete?",apiName:'Is_the_electrical_work_complete__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate','Trench']
            },
            {name:"Was the MPU completed?",apiName:'Was_the_MPU_completed__c',type:'yesNo',showWT:false,
                wt:['MPU']
            },
            {name:"Was there a utility inspection?",apiName:'Was_there_a_utility_inspection__c',type:'yesNo',showWT:false,
                wt:['MPU','Derate']
            },
            {name:"Was power restored to the home?",apiName:'Was_power_restored_to_the_home__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery','MPU','Subpanel Upgrade']
            },
            {name:"Why wasn’t power restored to the home?",apiName:'Why_wasn_t_power_restored_to_the_home__c',type:'multiPicklist',showWT:false,cField:'Was_power_restored_to_the_home__c',cValue:'No',
                wt:['Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate']
            },
            {name:"Is the battery install complete?",apiName:'Is_the_Battery_Install_Complete__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery']
            },
            {name:"Why hasn’t the battery been installed?",apiName:'Why_hasn_t_the_battery_been_installed__c',type:'multiPicklist',showWT:false,cField:'Is_the_Battery_Install_Complete__c',cValue:'No',
                wt:['Backup Battery','TOU Battery']
            },
            {name:"120% Rule: Is the PCS feature set up?",apiName:'X120_Rule_Is_the_PCS_feature_set_up__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery','MPU','Service']
            },
            {name:"Did the customer confirm the circuits?",apiName:'Did_the_customer_confirm_the_circuits__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery']
            },
            {name:"Was battery backup tested for 10 min?",apiName:'Was_battery_backup_tested_for_10_min__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery']
            },
            {name:"Customer registered while commissioning?",apiName:'Customer_registered_while_commissioning__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery']
            },
            {name:"Is the customer registered with Tesla?",apiName:'Is_the_customer_registered_with_Tesla__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery']
            },
            {name:"Gateway Serial Number",apiName:'Gateway_Serial_Number__c',type:'text',showWT:false,
                wt:['Backup Battery','TOU Battery']
            },
            {name:"Was the solar tied in?",apiName:'Was_the_solar_tied_in__c',type:'yesNo',showWT:false,
                wt:['Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel']
            },
            {name:"Monitoring fully set up, photo uploaded?",apiName:'Monitoring_fully_set_up_photo_uploaded__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Install','Backup Battery','TOU Battery']
            },
            {name:"Are all panels paired?",apiName:'Are_all_panels_paired__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"Why wasn’t the system paired?",apiName:'Why_wasn_t_the_system_paired__c',type:'picklist',showWT:false,cField:'Are_all_panels_paired__c',cValue:'No',
                wt:['Install','Backup Battery','TOU Battery']
            },
            {name:"Were the CTs verified as correct?",apiName:'Were_the_CTs_verified_as_correct__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"Does the system appear functional?",apiName:'Does_the_system_appear_functional__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Does the system have S-OK?",apiName:'Does_the_system_have_S_OK__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"Inverter/optimizer needs to be RMAed?",apiName:'Inverter_optimizer_needs_to_be_RMAed__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"Case/RMA Number",apiName:'Case_RMA_Number__c',type:'text',showWT:false,cField:'Inverter_optimizer_needs_to_be_RMAed__c',cValue:'Yes',
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"What is the old serial number?",apiName:'What_is_the_old_serial_number__c',type:'text',showWT:false,
                wt:['Service']
            },
            {name:"What is the new serial number?",apiName:'What_is_the_new_serial_number__c',type:'text',showWT:false,
                wt:['Service']
            },
            {name:"Was the derate completed?",apiName:'Was_the_derate_completed__c',type:'yesNo',showWT:false,
                wt:['Derate']
            },
            {name:"Why wasn’t the derate completed?",apiName:'Why_wasn_t_the_derate_completed__c',type:'textarea',showWT:false,cField:'Was_the_derate_completed__c',cValue:'No',
                wt:['Derate']
            },
            {name:"Was the new subpanel installed?",apiName:'Was_the_new_subpanel_installed__c',type:'yesNo',showWT:false,
                wt:['New Subpanel']
            },
            {name:"Was the SPAN panel installed?",apiName:'Was_the_SPAN_panel_installed__c',type:'yesNo',showWT:false,ewName:'SPAN Panel',
                wt:['New Subpanel']
            },
            {name:"Was the subpanel upgraded?",apiName:'Was_the_subpanel_upgraded__c',type:'yesNo',showWT:false,
                wt:['Subpanel Upgrade']
            },
            {name:"Why wasn’t the subpanel completed?",apiName:'Why_wasn_t_the_subpanel_completed__c',type:'textarea',showWT:false,cField:'Was_the_new_subpanel_installed__c',cValue:'No',
                wt:['Subpanel Upgrade','New Subpanel']
            },
            {name:"Is a trench needed?",apiName:'Is_a_trench_needed__c',type:'yesNo',showWT:false,
                wt:['Install','Trench']
            },
            {name:"Was the trench completed?",apiName:'Was_the_trench_completed__c',type:'yesNo',showWT:false,ewName:'Trench',
                wt:['Trench']
            },
            {name:"Was sand required but not filled in?",apiName:'Was_sand_required_but_not_filled_in__c',type:'yesNo',showWT:false,
                wt:['Trench','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"What was the trench inspection outcome?",apiName:'What_was_the_trench_inspection_outcome__c',type:'picklist',showWT:false,ewName:'Trench Inspection',
                wt:['Trench','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was the breaker relocation completed?",apiName:'Was_the_breaker_relocation_completed__c',type:'yesNo',showWT:false,ewName:'Relocating Breakers',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate']
            },
            {name:"Was the 220V outlet installed?",apiName:'Was_the_220V_outlet_installed__c',type:'yesNo',showWT:false,ewName:'220V Outlet',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate']
            },
            {name:"Was the EV charger installed?",apiName:'Was_the_EV_charger_installed__c',type:'yesNo',showWT:false,ewName:'EV Charger',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate']
            },
            {name:"Was the transfer switch completed?",apiName:'Was_the_transfer_switch_completed__c',type:'yesNo',showWT:false,ewName:'Transfer Switch',
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"What is the type of transfer switch?",apiName:'What_is_the_type_of_transfer_switch__c',type:'picklist',showWT:false,ewName:'Transfer Switch',
                wt:['Install','Backup Battery','TOU Battery']
            },
            {name:"Was other electrical work completed?",apiName:'Was_other_electrical_work_completed__c',type:'yesNo',showWT:false,ewName:'Other',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate']
            },
            {name:"Is internet access available?",apiName:'Is_internet_access_available__c',type:'multiPicklist',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','Service']
            },
            {name:"Is labeling completed?",apiName:'Is_labeling_completed__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Was the placard installed?",apiName:'Was_the_placard_installed__c',type:'yesNo',showWT:false,
                wt:['Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Is the conduit painted?",apiName:'Is_the_conduit_painted__c',type:'yesNo',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Why wasn’t the conduit painted?",apiName:'Why_wasn_t_the_conduit_painted__c',type:'picklist',showWT:false,cField:'Is_the_conduit_painted__c',cValue:'No',
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Service','Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            },
            {name:"Is there any damage to siding/stucco?",apiName:'Is_there_any_damage_to_siding_stucco__c',type:'yesNo',showWT:false,showTooltip:true,
                wt:['Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel']
            },
            {name:"Does the AHJ require a lathe inspection?",apiName:'Does_the_AHJ_require_a_lathe_inspection__c',type:'yesNo',showWT:false,
                wt:['MPU']
            },
            {name:"Upgrade ready for final inspection?",apiName:'Upgrade_ready_for_final_inspection__c',type:'yesNo',showWT:false,
                wt:['MPU','Subpanel Upgrade']
            },
            {name:"Electrical Notes",apiName:'Electrical_Notes__c',type:'textarea',showWT:false,
                wt:['Install','Backup Battery','TOU Battery','MPU','Subpanel Upgrade','New Subpanel','Derate']
            }, 
            {name:"Job Notes",apiName:'Job_Notes__c',type:'textarea',showWT:false,
                wt:['Install', 'Backup Battery', 'TOU Battery', 'MPU', 'Subpanel Upgrade', 'New Subpanel', 'Derate', 'Trench', 'Service', 'Site Survey', 'QA', 'Lathe Inspection','Fire Inspection','Final Inspection','Meter Inspection','Trench Inspection']
            }
        ],

        canceledFields: ['Cancellation_Type__c','What_was_the_reason_for_canceling__c','Job_Notes__c'],
        electricalWorkQuestions: ['Was_the_trench_completed__c','What_was_the_trench_inspection_outcome__c','Was_the_breaker_relocation_completed__c',
            'Was_the_220V_outlet_installed__c','Was_the_EV_charger_installed__c','Was_the_transfer_switch_completed__c','What_is_the_type_of_transfer_switch__c',
            'Was_other_electrical_work_completed__c','Was_the_SPAN_panel_installed__c'
        ],

        finspReasons: [
            { 
                label: 'Plans don’t match', 
                value: 'Plans don’t match', 
                nested: [
                    'Module placement','Battery equipment placement','Incorrect Wire size','Incorrect AC Disconnect Size',
                    'Incorrect Module','Incorrect Battery','Incorrect Inverter size','MSP'
                ] 
            },
            { 
                label: 'Install is wrong. Plans are correct.', 
                value: 'Install is wrong. Plans are correct.', 
                nested: [] 
            },
            { 
                label: 'Grounding', 
                value: 'Grounding', 
                nested: [
                    'Ufer not verified.','Ground rod(s) not installed.','Gas/Water not bonded.',
                    'Equipment conduit not grounded.','Rails not grounded','Using self tapping screws when machine screws are required'
                ] 
            },
            { 
                label: 'Breakers', 
                value: 'Breakers', 
                nested: [
                    'Wrong size breaker.','Wrong brand/type breaker.','Solar breaker in the wrong location in MSP/Subpanels.',
                    'Surge protector not installed.','AFCI breakers required.'
                ] 
            },
            { 
                label: 'Array wire management', 
                value: 'Array wire management', 
                nested: [
                    'Low hanging wires','Wire exposure (AHJ specific)'
                ] 
            },
            { 
                label: 'Conductor', 
                value: 'Conductor', 
                nested: [
                    'Wrong wire size','Damaged wire','Plans indicate wrong size conductors.'
                ] 
            },
            { 
                label: 'Smoke and carbon monoxide detector form', 
                value: 'Smoke and carbon monoxide detector form', 
                nested: [
                    'Detectors not installed properly'
                ] 
            },
            { 
                label: 'Conduit fill/Raceway', 
                value: 'Conduit fill/Raceway', 
                nested: [
                    'Exceeds max fill of 40%','Wrong size raceway used','Wrong type raceway',
                    'Exceeds 30 conductors in any vertical cross section.','Not painted'
                ] 
            },
            { 
                label: 'Mount', 
                value: 'Mount', 
                nested: [
                    'Mounts exceed plan maximum span.','Mounts not staggered as required.',
                    'Mounts Not lagged into a truss.','Wrong mounting equipment'
                ] 
            },
            { 
                label: 'Wrong ACD installed', 
                value: 'Wrong ACD installed', 
                nested: [
                    'Fused/ Non-fused ACD','Wrong ACD rating','Wrong ACD brand','ACD Location'
                ] 
            },
            { 
                label: 'Batteries', 
                value: 'Batteries', 
                nested: [
                    'Wrong type of lag used for mounting.','Mount not installed per specifications.',
                    'Battery in wrong location per plan','Battery too close to Door or Window.'
                ] 
            },
            { 
                label: 'Heat detector', 
                value: 'Heat detector', 
                nested: [] 
            },
            { 
                label: 'Toilet efficiency form', 
                value: 'Toilet efficiency form', 
                nested: [] 
            },
            { 
                label: 'Module', 
                value: 'Module', 
                nested: [
                    'Wrong module size','Wrong brand module','Cantilever','Fire offset'
                ] 
            },
            { 
                label: 'Roof quality', 
                value: 'Roof quality', 
                nested: [
                    'Broken tiles'
                ] 
            },
            { 
                label: 'Equipment clearances (non - module/battery/ACD)', 
                value: 'Equipment clearances (non - module/battery/ACD)', 
                nested: [] 
            },
            { 
                label: 'Labeling', 
                value: 'Labeling', 
                nested: [
                    'Placard','Conduit labeling','Deadfront labeling'
                ] 
            },
            { 
                label: 'Other – Type', 
                value: 'Other – Type', 
                nested: [] 
            },
        ],
        selectedOptions: [],
        nestedSelections: {},

        activeFieldPersonnel: [],
        fieldTeam: [],
        assignedCrew: {},
        shouldShowTooltip: false,
        tooltipTitle: '',
        tooltipBody: '',

        ToDoListArray: [],
        showServiceInfo: false,
        showFollowUpNeededSection: false,
        extraTimeNeededMap: [], // used to populate the extra time needed section.
        subcontractor: false,

        // variables for the confirm techs on site section.
        addingNewTech: false,
        newTech: {} // holds information of the new tech being added.
    };

    componentDidMount(){
        window.scrollTo(0, 0);
        this.getWorkOrder();
        this.getPickListValues();
    }

    getWorkOrder = () => {
        axios.post(
            `/sf/WorkOrder/findNo/`,
            this.postRequestFields,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                // Field_Team_Pay_IDs__c is set when job is started, but having this as a safe guard in case old job is being openned.
                if(data.Field_Team_Pay_IDs__c === null){
                    let fieldTeam = [];

                    if(data.Assigned_Field_Team__r.Tech_1__r) {
                        fieldTeam.push(data.Assigned_Field_Team__r.Tech_1__r);
                    }
                    if(data.Assigned_Field_Team__r.Tech_2__r) {
                        fieldTeam.push(data.Assigned_Field_Team__r.Tech_2__r);
                    }
                    if(data.Assigned_Field_Team__r.Tech_3__r) {
                        fieldTeam.push(data.Assigned_Field_Team__r.Tech_3__r);
                    }
                    if(data.Assigned_Field_Team__r.Tech_4__r) {
                        fieldTeam.push(data.Assigned_Field_Team__r.Tech_4__r);
                    }
                    if(data.Assigned_Field_Team__r.Tech_5__r) {
                        fieldTeam.push(data.Assigned_Field_Team__r.Tech_5__r);
                    }

                    if(data.Assigned_Field_Team_2__r){
                        if(data.Assigned_Field_Team_2__r.Tech_1__r) {
                            fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_1__r);
                        }
                        if(data.Assigned_Field_Team_2__r.Tech_2__r) {
                            fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_2__r);
                        }
                        if(data.Assigned_Field_Team_2__r.Tech_3__r) {
                            fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_3__r);
                        }
                        if(data.Assigned_Field_Team_2__r.Tech_4__r) {
                            fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_4__r);
                        }
                        if(data.Assigned_Field_Team_2__r.Tech_5__r) {
                            fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_5__r);
                        }
                    }
                    fieldTeam = fieldTeam.filter(tech => tech.Payroll_ID__c !== null);

                    this.setState({fieldTeam});
                }

                if(data.Assigned_Field_Team__r.Subcontractor__c){
                    this.setState({subcontractor: true});
                }

                let remainingEW = null;
                let ewQuestions = this.state.electricalWorkQuestions;
                if(data.Opportunity__c !== null && data.Opportunity__r.Electrical_Work__c !== null && data.Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c !== null){
                    remainingEW = data.Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c;
                }

                let batteryType = null;

                if(data.Opportunity__c !== null && data.Opportunity__r.Battery_Type__c !== null && data.Opportunity__r.Battery_Type__r.Name !== null){
                    batteryType = data.Opportunity__r.Battery_Type__r.Name;
                }

                if(data.Work_Types__c.includes('Service') && data.Case__c !== null && data.Case__r.ToDoListValues__c !== null){
                    let toDoList = data.Case__r.ToDoListValues__c;
                    this.setState({ToDoListArray: toDoList.split('%#'), showServiceInfo: true});
                }

                const workTypeFieldsMap = {
                    'Install': ['Install_Work_Duration_hours__c', 'Install_Work_Duration_Completed_hours__c'],
                    'Backup Battery': ['Backup_Work_Duration_hours__c', 'Backup_Work_Duration_Completed_hours__c'],
                    'TOU Battery': ['TOU_Work_Duration_hours__c', 'TOU_Work_Duration_Completed_hours__c'],
                    'MPU': ['MPU_Work_Duration_hours__c', 'MPU_Work_Duration_Completed_hours__c'],
                    'Subpanel Upgrade': ['Subpanel_Upgrade_Work_Duration_hours__c', 'Subpanel_Upgrade_Duration_Completed_hrs__c'],
                    'New Subpanel': ['New_Subpanel_Work_Duration_hours__c', 'New_Subpanel_Duration_Completed_hours__c'],
                    'Derate': ['Derate_Work_Duration_hours__c', 'Derate_Work_Duration_Completed_hours__c'],
                    'Trench': ['Trench_Work_Duration_hours__c', 'Trench_Work_Duration_Completed_hours__c'],
                    'Service': ['Service_Work_Duration_hours__c', 'Service_Work_Duration_Completed_hours__c'],
                    'Trench Inspection': ['Trench_Inspection_Work_Duration_hours__c', 'Trench_Inspection_Duration_Completed_hrs__c'],
                    'Misc Electrical': ['Misc_Electrical_Work_Duration_hours__c', 'Misc_Electrical_Duration_Completed_hrs__c'],
                };

                let extraTimeNeededMap = [];
                let workTypes = data.Work_Types__c?.split(';');
                workTypes.forEach(workType => {
                    // Do not show for site survey, or inspection work types besides trench inspection.
                    if(workType !== 'Site Survey' && (!workType.includes('Inspection') || workType === 'Trench Inspection')){
                        const fields = workTypeFieldsMap[workType];
                        if(!fields) return; // skip the logic if this work type is not in the map.

                        const [totalHoursFieldName, completedHoursFieldName] = fields;
                        const totalHours = data.Job_Overview__r?.[totalHoursFieldName];
                        const completedHours = data.Job_Overview__r?.[completedHoursFieldName] || 0;

                        // Show this work type as follow up needed only if this is the last work order for this work type.
                        if(totalHours !== null && completedHours !== null && data.Duration__c && totalHours - completedHours === (data.Duration__c / 60.0)){
                            extraTimeNeededMap.push({
                                workType: workType,
                                totalHoursFieldName: totalHoursFieldName,
                                hoursToAdd: '', // empty string so the input field is empty. This way user doesn't need to erase 0 when they want to add some extra time.
                            });
                        }
                    }
                });
                this.setState({extraTimeNeededMap});

                let mappedFields = _.cloneDeep(this.state.mappedFields);

                _.forEach(mappedFields, function(field) {
                    if(field.wt){
                        _.forEach(field.wt, function(type) {
                            if(data.Work_Types__c.includes(type)){
                                field.showWT = true;

                                if(ewQuestions.includes(field.apiName) && remainingEW !== null && remainingEW.includes(field.ewName)){
                                    field.showWT = true;
                                } else if(ewQuestions.includes(field.apiName) && remainingEW !== null && !remainingEW.includes(field.ewName)){
                                    field.showWT = false;
                                }

                                // Show Was_the_Safe_Harbor_equipment_delivered__c only if opportunity needs safe harbor
                                if(field.apiName === 'Was_the_Safe_Harbor_equipment_delivered__c' && field.showWT && data.Opportunity__r.Safe_Harbor_Needed__c === null){
                                    field.showWT = false;
                                }

                                if((field.apiName === 'Is_the_customer_registered_with_Tesla__c' || field.apiName === 'Gateway_Serial_Number__c') && field.showWT && batteryType !== null && !batteryType.includes('Tesla')){
                                    field.showWT = false;
                                }

                                return;
                            }
                        });
                    }
                });

                this.setState({workOrder: data, mappedFields})

                // need to get the active field only after this.state.workOrder is set, so we can get the Field_Team_Pay_IDs__c value
                this.getActiveField();
            })
            .catch(err => console.log('POST Error:\n', err));
    }

    getPickListValues = () => {
        axios.get(
            '/sf/WorkOrder/describeField/Outcome__c;Failed_Inspection_Reason_s__c;Is_the_job_ready_for_final_inspection__c;Cancellation_Type__c;What_was_the_reason_for_canceling__c;' +
            'Reason_for_not_completing_work__c;Did_you_have_all_necessary_equipment__c;What_work_is_remaining__c;Estimated_time_needed_to_finish_job__c;' +
            'Was_the_customer_informed_of_job_status__c;Can_the_customer_turn_on_the_system__c;Did_the_customer_approve_the_plans__c;CAD_Errors__c;' +
            'Are_the_rain_gutters_clean_of_debris__c;Is_a_roof_service_call_needed__c;What_electrical_work_needs_to_be_fixed__c;Why_wasn_t_power_restored_to_the_home__c;' +
            'Why_hasn_t_the_battery_been_installed__c;X120_Rule_Is_the_PCS_feature_set_up__c;Why_wasn_t_the_system_paired__c;What_was_the_trench_inspection_outcome__c;' +
            'What_is_the_type_of_transfer_switch__c;Is_internet_access_available__c;Why_wasn_t_the_conduit_painted__c;Meter_release_inspection_outcome__c;' +
            'Ceiling_Type__c;Is_the_roof_mossy_or_slippery__c;Attic_Structure__c;What_is_the_roof_type__c;What_is_the_roof_condition__c;Ceiling_type_for_Structure_2__c;Attic_structure_type_for_Structure_2__c;Roof_mossy_slippery_for_Structure_2__c;Structure_2_tiles_fragile_lightweight__c;' +
            'Roof_condition_for_Structure_2__c;What_is_the_roof_type_for_Structure_2__c;What_waste_management_method_was_used__c;What_is_the_siding_type__c;What_is_the_utility_feed__c;MSP_Mounting__c;Grounding__c;' +
            'MSP_Condition__c;MSP_Brand__c;MSP_Feed__c;Main_Breaker_Rating__c;MSP_Busbar_Rating__c;Existing_PV_Breaker_Size__c;Existing_ACD__c;What_materials_are_in_the_trench_path__c;' +
            'What_work_was_partially_completed__c;What_work_was_fully_completed__c;Is_a_special_panel_present__c;Was_the_TRX_shared__c;Existing_generator_or_transfer_switch__c;Ground_Rod_811_Marking__c;System_A_Existing_Battery_Mfr__c;System_B_Existing_Battery_Mfr__c;What_is_the_RSS_reason__c;',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    getActiveField = () => {
        let payIds = this.state.workOrder.Field_Team_Pay_IDs__c?.split(';');

        let activeFieldPayload = {
            limit: 500,
            fields: {
                Id: 1,
                Name: 1,
                Payroll_ID__c: 1,
                Active__c: 1
            },
            where: {
                "$and": [
                    { "Payroll_ID__c": { "$ne": null } }, // important to be first, since it will remove most of the contacts in the org
                    { "$or": [
                        // The main criteria for showing options
                        {"$and": [
                            { "Active__c": true },
                            { "Job_Department__c": { "$in": ["Installation", "Electrician", "Service Call", "Inspection"]}}
                        ]}, 
                        { "Payroll_ID__c": { "$in": payIds } } // This is needed to make sure that if a tech was on field team and is now deactivated that he still shows correctly.
                    ]}
                ]
            },
            orderBy: {
                Name: 1
            }
        };

        axios.post(
            '/sf/contact/findNo',
            activeFieldPayload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                const fieldTechs = data?.records;

                this.setState({
                    activeFieldPersonnel: fieldTechs,
                }); 

                if(this.state.workOrder.Field_Team_Pay_IDs__c && fieldTechs?.length > 0){
                    const payrollIdToTech = {};

                    fieldTechs.forEach(tech => {
                        // While testing found out that we reuse Payroll Id, so there are some active techs that have same payroll id as some inactive techs. 
                        // This check just makes sure that it will return the active tech, and if there is no, it will return the first inactive
                        if(payIds.includes(tech.Payroll_ID__c) && (!payrollIdToTech[tech.Payroll_ID__c] || tech.Active__c === true)){
                            payrollIdToTech[tech.Payroll_ID__c] = tech;
                        }
                    });

                    const fieldTeam = Object.values(payrollIdToTech);

                    this.setState({fieldTeam});
                }
            })
            .catch(err => console.log('(GET) Error tyring to fetch active field personnel: ', err));
    };

    saveFields = (saveEnd) => {
        this.setState({disableSave: true});
        const payload = {...this.state.workOrder};
        delete payload.Assigned_Field_Team__r;
        delete payload.Assigned_Field_Team_2__r;
        delete payload.Opportunity__r;
        delete payload.Case__r;
        delete payload.Job_Overview__r;

        let inspOption = this.state.selectedOptions;

        if(this.state.selectedOptions.length !== 0){
            let inspSOption = this.state.nestedSelections;
            let failedIR = '';
            let failedISR = ''; 
            
            inspOption.forEach(option => {
                failedIR = failedIR + option + ';';
            });

            for(const key in inspSOption) {
                if(Object.hasOwnProperty.call(inspSOption, key)) {
                    let srArray = inspSOption[key];

                    srArray.forEach(option => {
                        failedISR = failedISR + option + ';';
                    });
                }
            }

            payload.Failed_Inspection_Reason_s__c = failedIR;
            payload.Failed_Inspection_Subreasons__c = failedISR;
        }

        if(this.state.fieldTeam.length !== 0){
            payload.Field_Team_Pay_IDs__c = this.state.fieldTeam.map(tech => tech.Payroll_ID__c).filter(Boolean).join(';');
        }

        if(this.state.showServiceInfo && this.state.ToDoListArray.length !== 0){
            this.saveToDoListToCase();
        }

        if(this.state.extraTimeNeededMap.length > 0 && (this.state.workOrder.Outcome__c === 'Partial Completion' || this.state.workOrder.Outcome__c === 'Fail')){
            this.updateDurationsOnJobOverview();
        }

        if(saveEnd === 'save' && this.validationSaveCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});

            this.updateWorkOrder(payload);
        } else if(saveEnd === 'end' && this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.EOJ_Status__c = 'Complete';

            if(payload.Outcome__c === 'Canceled'){
                payload.Cancel_Date_Time__c = moment().format(this.SF_DATE_TIME_FORMAT);
            }

            this.updateWorkOrder(payload);
        } else {
            // In case validationSaveCheck or validationCompleteCheck fails, we need to reset the disableSave state to false so the user can try again.
            this.setState({disableSave: false});
        }
    };

    updateWorkOrder = (payload) => {
        axios.put(
            '/sf/WorkOrder/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                setTimeout(() => {
                    this.getWorkOrder();
                }, 1500);

                setTimeout(() => {
                    this.setState({isEditing: false, disableSave: false});
                }, 2500);
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update work order: \n', err);
                this.setState({disableSave: false});
            });
    }

    validationSaveCheck = (payload) => {
        let valid = true;

        if(payload['Job_Notes__c'] !== null && payload['Job_Notes__c'].length > 5000) {
            this.setState({shouldShowAlert: true, alertMessage: 'Too Many Characters for Field Notes'})
            valid = false;
        }

        if(this.state.subcontractor === false && this.state.fieldTeam.length === 0){
            this.setState({shouldShowAlert: true, alertMessage: 'At Least One Tech Needs To Be Selected'})
            valid = false;
        }

        if(valid === false){
            this.setState({disableSave: false});
        }

        return valid;
    };

    validationCompleteCheck = (payload) => {
        let valid = true;

        if(this.validationSaveCheck(payload)){
            if(payload['Outcome__c'] === '' || payload['Outcome__c'] === null) {
                this.setState({shouldShowAlert: true, alertMessage: 'Outcome needs to be filled out before ending job'});
                valid = false;
            }

            if(payload['Outcome__c'] === 'Canceled') {
                if(payload['Cancellation_Type__c'] === null || payload['What_was_the_reason_for_canceling__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please fill out Cancellation Type and Reason for Canceling'});
                    valid = false;
                }
            }

            if(payload['Outcome__c'] !== 'Canceled') {
                for (const key in payload) {
                    if(this.reqFields.includes(key)){
                        if(payload[key] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Required Fields (*) Before Ending Job'})
                            valid = false;
                            break;
                        }
                    }
                }

                if(payload['Are_there_any_broken_tiles__c'] === 'Yes' && payload['Were_all_the_broken_tiles_fixed__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please notate if the broken tiles were fixed'});
                    valid = false;
                }

                if(payload['Is_a_design_revision_needed__c'] === 'Yes' && payload['CAD_Errors__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please select the CAD Errors'});
                    valid = false;
                }

                if(this.state.workOrder.Work_Types__c.includes('Inspection') && (payload['Digital_Inspection_Result__c'] === null || payload['Digital_Inspection_Result__c'] === '')){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please select the Digital Inspection Result'});
                    valid = false;
                }

                if(this.state.workOrder.Work_Types__c.includes('MPU') && (payload['Meter_release_inspection_outcome__c'] === null || payload['Meter_release_inspection_outcome__c'] === '')){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please select the Meter Release Inspection Outcome'});
                    valid = false;
                }

                if(this.state.workOrder.Work_Types__c.includes('Site Survey') && (payload['Meter_Number__c'] === null || payload['Meter_Number__c'] === '')){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please fill in the Meter Number'});
                    valid = false;
                }
                if(this.state.workOrder.Work_Types__c.includes('Site Survey') && (payload['Are_there_any_unpermitted_structures__c'] === null || payload['Are_there_any_unpermitted_structures__c'] === '')){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please complete the unpermitted structures question'});
                    valid = false;
                }
            }
        } else {
            valid = false;
        }

        return valid;
    };

    // Handles the type of field needing to be entered and will list out their values
    // Also handles updating the state of the field being passed so additional logic 
    // can be ran and the form be built for saving the fields to salesforce.
    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.fieldOnChange(field, event.target.value)}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.fieldOnChange(field, event.target.value)}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'multiPicklist':
                return(
                    <div className="pb-4">
                        <select onChange={(event) => this.assignMultiple(field, event.target.selectedOptions)} value={fieldProps ? fieldProps.split(';') : []} multiple>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.fieldOnChange(field, event.target.value)}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.fieldOnChange(field, event.target.value)}
                        />
                    </div>
                );
            case 'checkbox':
                return(
                    <div className="pb-4">
                        <input
                            type="checkbox"
                            defaultChecked={fieldProps ? fieldProps : false}
                            onChange={(event) => this.fieldOnChange(field, !event.target.defaultChecked)}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.fieldOnChange(field, event.target.value)}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    // Handles updating the newly entered value for the work order
    // and setting state copying over the edited field
    fieldOnChange = (fieldName, value) => {
        const editFields = _.cloneDeep(this.state.workOrder);
        editFields[fieldName] = value;
        this.setState({workOrder:editFields});
    };

    // Logic to handle Multi-Select fields and format them for Salesforce
    assignMultiple = (fieldName, value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        const editFields = _.cloneDeep(this.state.workOrder);
        editFields[fieldName] = groupedValues;
        this.setState({workOrder:editFields});
    };

    setTooltipInfo = (value) => {
        this.setState({shouldShowTooltip: true});

        switch (value) {
            case 'Outcome__c':
                this.setState({
                    tooltipTitle: 'Install Outcome',
                    tooltipBody: 'Full completion: All panels laid, wire pulls done, system commisioned, no need to return<br></br>Partial completion: Some electrical or roof work has been done, but we need to return for follow up'
                })
                break;

            case 'Did_the_customer_approve_the_plans__c': 
                this.setState({
                    tooltipTitle: 'Did the customer approve plans',
                    tooltipBody: 'Did customer see plans beforehand and approve of placement and layout of all equipment'
                })
                break;

            case 'Was_the_roof_work_completed__c': 
                this.setState({
                    tooltipTitle: 'Roof work complete',
                    tooltipBody: 'All panels laid, wire pulls done, no need to return, JBox Wired, Wire Pull Complete, Commissioning Screen Shots (Unless pending MPU), Photos Approved, [Derate, SubPanel, EV Charger, Transfer Switch, Photos Approved] if needed'
                })
                break;

            case 'Was_the_customer_informed_of_job_status__c': 
                this.setState({
                    tooltipTitle: 'Customer knows the status of the job?',
                    tooltipBody: 'Does customer know the next step of their project (follow up, handyman, inspection, what was done today)?'
                })
                break;

            case 'Is_the_job_ready_for_final_inspection__c':
                this.setState({
                    tooltipTitle: 'Ready for final inspection?',
                    tooltipBody: 'Inspection will pass, no follow up work needed, work matches plans, no sididng needs to be repaired'
                })
                break;

            case 'Was_the_final_walkthrough_completed__c': 
                this.setState({
                    tooltipTitle: 'Final walkthrough complete?',
                    tooltipBody: 'Walk around customers property, no trash/tools/equipment left behind'
                })
                break;

            case 'Is_the_Battery_Install_Complete__c': 
                this.setState({
                    tooltipTitle: 'Is the battery install complete?',
                    tooltipBody: 'Battery hung, piped, wire pull, commissoned; no need to return for any battery work'
                })
                break;

            case 'Is_the_customer_registered_with_Tesla__c': 
                this.setState({
                    tooltipTitle: 'Is customer registered with Tesla',
                    tooltipBody: 'Did you get a screen shot of the customers email showing they are registered'
                })
                break;

            case 'Gateway_Serial_Number__c': 
                this.setState({
                    tooltipTitle: 'Gateway Serial Number',
                    tooltipBody: 'Serial Number on the side of the Battery'
                })
                break;

            case 'Was_battery_backup_tested_for_10_min__c': 
                this.setState({
                    tooltipTitle: 'Tested battery backup for 10 minutes?',
                    tooltipBody: 'Simulated power outage for 10 min and got pictures'
                })
                break;

            case 'Did_the_customer_confirm_the_circuits__c': 
                this.setState({
                    tooltipTitle: 'Customer confirmed circuits?',
                    tooltipBody: 'Customer confirmed which circuits will be backed up'
                })
                break;

            case 'Were_the_CTs_verified_as_correct__c': 
                this.setState({
                    tooltipTitle: 'Verify CTs are correct',
                    tooltipBody: 'Are they facing the correct direction, are they in the correct location, existing solar has CTs on them if applicable (verify by having no negative home loads, Enphase CTs arrows face the loads, existing solar with enphase the CT(2) arrow faces away from breaker and landed as production)'
                })
                break;

            case 'X120_Rule_Is_the_PCS_feature_set_up__c': 
                this.setState({
                    tooltipTitle: 'If the sum of the amps for the battery and solar exceeds the 120% rule did we setup the PCS feature?',
                    tooltipBody: 'Did we put in the PCS on what the plans say on the SLD  Does the PCS match the plans?'
                })
                break;

            case 'X3_Foot_Fire_Clearance_Met__c': 
                this.setState({
                    tooltipTitle: '3 foot fire clearance met?',
                    tooltipBody: 'Are the batteries at least 3ft away from doors, windows, and each other?'
                })
                break;

            case 'Customer_registered_while_commissioning__c': 
                this.setState({
                    tooltipTitle: 'Was the customer registered during commissioning?',
                    tooltipBody: 'Did you get a screen shot of the customers email showing they are registered '
                })
                break;

            case 'Is_there_any_damage_to_siding_stucco__c': 
                this.setState({
                    tooltipTitle: 'Any damage to siding/stucco?',
                    tooltipBody: 'Does a handyman need to come and repair stucco/siding'
                })
                break;

            case 'Was_power_restored_to_the_home__c': 
                this.setState({
                    tooltipTitle: 'Has power been restored to the home?',
                    tooltipBody: 'Verified that customer circuits AND AC works'
                })
                break;

            case 'Monitoring_fully_set_up_photo_uploaded__c': 
                this.setState({
                    tooltipTitle: 'Monitoring set up?',
                    tooltipBody: 'Is the system fully commissoned'
                })
                break;

            default:
                break;
        }
    };

    // Handler for selecting main checkboxes
    handleOptionChange = (value) => {
        this.setState((prevState) => {
            const { selectedOptions } = prevState;
            const newSelectedOptions = selectedOptions.includes(value)
                ? selectedOptions.filter(item => item !== value)
                : [...selectedOptions, value];

            return { selectedOptions: newSelectedOptions };
        });

        console.log(this.state.selectedOptions);
    };

    // Handler for selecting nested checkboxes
    handleNestedChange = (mainValue, nestedValue) => {
        this.setState((prevState) => {
            const prevNested = prevState.nestedSelections[mainValue] || [];
            const newNestedSelections = prevNested.includes(nestedValue)
                ? prevNested.filter(item => item !== nestedValue)
                : [...prevNested, nestedValue];

            return {
                nestedSelections: {
                    ...prevState.nestedSelections,
                    [mainValue]: newNestedSelections
                }
            };
        });
    };

    saveToDo = (item) => {
        let tempArray = this.state.ToDoListArray;
        let index = tempArray.indexOf(item);

        if(index !== -1) {
            let newItem;

            if(item.includes('<s>')){
                newItem = item.replace(/<\/?s>/g, "");
            } else{
                newItem = '<s>' + item + '</s>';
            }

            tempArray[index] = newItem;

            this.setState({ToDoListArray: tempArray});
        } else {
            console.log('Item not found');
        }
    };

    saveToDoListToCase = () =>{
        if(this.state.ToDoListArray.length !== 0 && this.state.workOrder.Case__c !== null){
            let toDoList = '';

            this.state.ToDoListArray.forEach(item => {
                toDoList = toDoList + item + '%#'
            });

            let payload = {
                Id: this.state.workOrder.Case__c,
                ToDoListValues__c: toDoList.slice(0, -2)
            }

            axios.put(
                '/sf/case/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update Case: \n', err));
        }
    }

    updateDurationsOnJobOverview = () => {
        let jobOverview = this.state.workOrder.Job_Overview__r;

        let payload = {};

        this.state.extraTimeNeededMap.forEach(item => {
            if(item.hoursToAdd > 0){
                payload[item.totalHoursFieldName] = parseFloat(jobOverview[item.totalHoursFieldName] ?? 0) + parseFloat(item.hoursToAdd);
            }
        });

        // Only update the job overview if there are any changes to the durations.
        if(Object.keys(payload).length > 0){
            payload.Id = this.state.workOrder.Job_Overview__c;

            axios.put(
                '/sf/JobOverview/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then(() =>
                {
                    this.setState({
                        shouldShowAlert: true,
                        alertMessage: 'Extra time was added successfully.'
                    });
                    setTimeout(() => {
                        this.setState({
                            shouldShowAlert: false,
                        });
                    }, 5500);
                })
        }
    }

    handleExtraHoursChange = (workType, newValue) => {
        let hoursToAdd = newValue;
        if(hoursToAdd < 0) hoursToAdd = 0; // min
        if(hoursToAdd > 999) hoursToAdd = 999; // max
        if(hoursToAdd && hoursToAdd.includes('.')) hoursToAdd = Math.floor(hoursToAdd * 10) / 10; // only one decimal place.

        this.setState(prev => ({
            extraTimeNeededMap: prev.extraTimeNeededMap.map(item => item.workType === workType ? { ...item, hoursToAdd: hoursToAdd } : item)
        }));
    };

    removeTechOnClick = (payId) => {
        let fieldTeam = this.state.fieldTeam;
        fieldTeam = fieldTeam.filter(tech => tech.Payroll_ID__c !== payId);
        this.setState({fieldTeam});
    }

    addTechOnClick = (tech) => {
        let fieldTeam = this.state.fieldTeam;
        fieldTeam.push(tech);
        this.setState({fieldTeam, addingNewTech: false});
    }

    render(){
        if(Object.keys(this.state.workOrder).length){
        return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            
            {/* Header of Field Job Form and includes buttons to End Job and Save */}
            <div className="d-flex justify-content-between mt-5 mb-4">
                <Link to={ this.state.workOrder.Id ? `/workOrders/${this.state.workOrder.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" disabled={this.state.disableSave} onClick={() => this.saveFields('save')}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.state.workOrder.Jobsite_Photos__c ? this.state.workOrder.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.state.workOrder.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.saveFields('end')}>End Job</button>
            </div>

            <div className={this.state.workOrder.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.saveFields('end')}>Job Completed</button>
            </div>
            {/* End of Header */}

            {
                this.state.isEditing ?

                // Render when editing
                // 

                <div className="text-white">
                    <h2 className="pt-4">Work Order: {this.state.workOrder.Work_Types__c}</h2>

                    <div className={this.state.subcontractor === false ? "pb-4" : "d-none"}>
                        <div className="row">
                            <label className="col-sm-5 col-12 m-0 py-2 text-white pl-3">
                            Confirm Members On Site:
                            </label>
                        </div>

                       <div className="border border-light">
                            {this.state.fieldTeam.map((tech, index) => (
                                <div className="row mx-0 border-bottom align-items-center" key={tech.Payroll_ID__c}>
                                    <div className="col d-flex align-items-center">
                                        <span className="flex-grow-1">{tech.Name}</span>
                                    </div>
                                    <div className="text-right">
                                        <button type="button" className="btn btn-secondary btn-sm mt-1 mb-1 mr-1" onClick={() => this.removeTechOnClick(tech.Payroll_ID__c)}>
                                            <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                    </div>
                                </div>
                            ))}

                            {this.state.addingNewTech ? (
                                <Downshift onChange={tech => this.setState({newTech: tech})} itemToString={item => (item ? item.Name : '')}>
                                    {({getInputProps,getItemProps,getMenuProps,clearSelection,isOpen,inputValue,highlightedIndex,selectedItem}) => (
                                    <div>
                                        <div className="row">
                                            <div className="col-12 d-flex align-items-center mb-2">
                                                <input className="form-control mt-1 ml-2 mr-2 flex-grow-1" placeholder="Type Tech's Name" {...getInputProps()}/>
                                                <button type="button" className="btn btn-success btn-sm mt-1 mr-1 ml-auto"
                                                    onClick={() => {
                                                        this.addTechOnClick(this.state.newTech);
                                                        clearSelection();
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </button>
                                                <button type="button" className="btn btn-secondary btn-sm mt-1 mr-1"
                                                    onClick={() => {
                                                        this.setState({ addingNewTech: false, newTech: {} });
                                                        clearSelection();
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                            <ul className="list-group" {...getMenuProps()}>
                                                    {isOpen ?
                                                        this.state.activeFieldPersonnel.filter(item => !inputValue || (item.Name).toLowerCase().includes(inputValue) || item.Name.includes(inputValue))
                                                            .slice(0, 3).map((item, index) => (
                                                            <li className="list-group-item" {...getItemProps({key: item.Name, index, item,
                                                                style: {
                                                                    backgroundColor: highlightedIndex === index ? 'lightgray' : 'black',
                                                                    fontWeight: selectedItem === item ? 'bold' : 'normal',
                                                                },
                                                                })}
                                                            >
                                                                {item.Name}
                                                            </li>
                                                        ))
                                                    : null}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>)}
                                </Downshift>
                            ) : null}
                        </div>

                        <div className={this.state.addingNewTech ? "d-none" :"row"}>
                            <div className="col-sm-7 col-12">
                                <button type="button" className="btn btn-primary btn-sm mt-2" onClick={() => this.setState({ addingNewTech: true })}>
                                    Add Tech
                                </button>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="Outcome__c">Outcome</label>
                        {
                            this.state.workOrder.Work_Types__c.includes('Inspection') ?
                            <div className="pb-4">
                            <select id='Outcome__c' value={this.state.workOrder.Outcome__c ? this.state.workOrder.Outcome__c : ''} onChange={(event) => this.fieldOnChange('Outcome__c', event.target.value)}>
                                <option value="" hidden disabled></option>
                                <option value="Pass">Pass</option>
                                <option value="Fail">Fail</option>
                                <option value="Canceled">Canceled</option>
                            </select>
                            </div>
                            :
                            <div className="pb-4">
                            <select id='Outcome__c' value={this.state.workOrder.Outcome__c ? this.state.workOrder.Outcome__c : ''} onChange={(event) => this.fieldOnChange('Outcome__c', event.target.value)}>
                                <option value="" hidden disabled></option>
                                <option value="Full Completion">Full Completion</option>
                                <option value="Partial Completion">Partial Completion</option>
                                <option value="Canceled">Canceled</option>
                            </select>
                            </div>
                        }
                    </div>

                    {
                        this.state.mappedFields.map((field) => {
                            return (
                                 <div key={field}>
                                    {
                                        // Logic to only show cancel fields when a work order is cancelled
                                        this.state.workOrder.Outcome__c === 'Canceled' && this.state.canceledFields.includes(field.apiName) ?
                                        <div>
                                            <label htmlFor={field.apiName}>{field.name}</label>
                                            {
                                                field.type !== 'picklist' && field.type !== 'multiPicklist' ?
                                                <>
                                                    {this.getInput(field.type, field.apiName, this.state.workOrder[field.apiName])}
                                                </>
                                                :
                                                <>
                                                    {this.getInput(field.type, field.apiName, this.state.workOrder[field.apiName], this.pickfields[field.apiName].picklistValues)}
                                                </>
                                            }
                                        </div>
                                        :

                                        // Logic to show relevant fields based on work types
                                        field.showWT && this.state.workOrder.Outcome__c !== 'Canceled' && field.apiName !== 'Failed_Inspection_Reason_s__c' ?

                                        <div className={field.cField ? (this.state.workOrder[field.cField] === field.cValue 
                                        || (field.cValue && this.state.workOrder[field.cField] && this.state.workOrder[field.cField]?.includes(field.cValue))) 
                                        ? '' : 'd-none' : ''}>
                                            <label htmlFor={field.apiName}>{field.name}</label>
                                            {
                                                field.showTooltip ? 
                                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faInfo} onClick={() => this.setTooltipInfo(field.apiName)} /></span>
                                                :
                                                <></>
                                            }
                                            {
                                                field.type !== 'picklist' && field.type !== 'multiPicklist' ?
                                                <>
                                                    {this.getInput(field.type, field.apiName, this.state.workOrder[field.apiName])}
                                                </>
                                                :
                                                <>
                                                    {this.getInput(field.type, field.apiName, this.state.workOrder[field.apiName], this.pickfields[field.apiName].picklistValues)}
                                                </>
                                            }
                                        </div>
                                        :
                                        // Logic to show failed inspection reasons and subreasons
                                        field.showWT && this.state.workOrder.Outcome__c !== 'Canceled' && !this.state.canceledFields.includes(field.apiName) && field.apiName === 'Failed_Inspection_Reason_s__c' ?

                                        <div className={field.cField ? (this.state.workOrder[field.cField] === field.cValue 
                                        || (field.cValue && this.state.workOrder[field.cField] && this.state.workOrder[field.cField]?.includes(field.cValue))) 
                                        ? '' : 'd-none' : ''}>
                                        <label htmlFor={field.apiName}>{field.name}</label>
                                        <div className={css["double-multi-picklist-container"]}>
                                        {
                                            this.state.finspReasons.map(option => (
                                            <div className={css["double-multi-picklist-option"]} key={option.value}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value={option.value}
                                                        checked={this.state.selectedOptions.includes(option.value)}
                                                        onChange={() => this.handleOptionChange(option.value)}
                                                    />
                                                    {option.label}
                                                </label>
                                                
                                                {/* Display nested checkboxes if parent is selected */}
                                                {this.state.selectedOptions.includes(option.value) && (
                                                    <div className={css["double-multi-picklist-options"]}>
                                                        <h4>Select {option.label} subreasons:</h4>
                                                        {option.nested.map(nestedOption => (
                                                            <div className={css["double-multi-picklist-option"]}>
                                                                <label key={nestedOption}>
                                                                    <input
                                                                        type="checkbox"
                                                                        value={nestedOption}
                                                                        checked={this.state.nestedSelections[option.value]?.includes(nestedOption) || false}
                                                                        onChange={() => this.handleNestedChange(option.value, nestedOption)}
                                                                    />
                                                                    {nestedOption}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                        </div>
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            );
                        })
                    }

                    {
                        this.state.showServiceInfo ?
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Service Case To-Do List:</label>
                            { 
                                this.state.ToDoListArray.length !== 0 ?
                                this.state.ToDoListArray.map((item, index) => (
                                    <div className="col-sm-7 col-12 py-2">    
                                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveToDo(item)}>Done</button><li className="d-inline px-4 text-white" key={index} dangerouslySetInnerHTML={{__html: item}}></li>
                                    </div>))
                                :
                                null
                            }
                        </div>
                        :
                        null
                    }

                    {
                        // Show the extra time needed section only if there is at least one work type that this work order is the last for, and if the outcome is partial completion.
                    this.state.extraTimeNeededMap.length > 0 && (this.state.workOrder.Outcome__c === 'Partial Completion' || this.state.workOrder.Outcome__c === 'Fail') ? (
                        <>
                        <div className="mt-3 mb-2 font-weight-bold">Extra Time Needed?</div>

                        <div className="table-responsive" style={{ maxWidth: '520px' }}>
                            <table className="table table-sm table-dark mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ width: '65%' }}>Work Type</th>
                                        <th style={{ width: '35%' }}>Estimated Hours Left</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.state.extraTimeNeededMap.map(item => (
                                    <tr key={item.workType}>
                                        <td className="align-middle">{item.workType}</td>
                                        <td className="align-middle">
                                            <input
                                                className="form-control form-control-sm d-inline-block"
                                                style={{ width: '80px', textAlign: 'right' }}
                                                type="number"
                                                placeholder={0}
                                                value={item.hoursToAdd}
                                                onChange={(e) => this.handleExtraHoursChange(item.workType, e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        </>
                    ) : null
                    }
                </div>

                :

                // RENDER WHEN NOT EDITING
                // 

                <div className="text-white">
                    <h2 className="pt-4">Work Order: {this.state.workOrder.Work_Types__c}</h2>

                    <div className={this.state.subcontractor === false ? "d-flex flex-column flex-sm-row align-items-start pb-3 mb-2" : "d-none"}>
                        <label className="col-sm-5 col-12 m-0 py-2">
                            Techs On Site:
                        </label>

                        <div className="col-sm-7 col-12">
                            <ul className="list-unstyled mb-0">
                            {this.state.fieldTeam.map((tech, index) => (
                                <li key={index}>{tech.Name}</li>
                            ))}
                            </ul>
                        </div>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Outcome</label>
                        <div className="d-inline col-sm-7 col-12">{this.state.workOrder.Outcome__c ? this.state.workOrder.Outcome__c : '---'}</div>
                    </div>

                    {
                        this.state.mappedFields.map((field) => {
                            return (
                                 <div key={field}>
                                    {
                                        this.state.workOrder.Outcome__c === 'Canceled' && this.state.canceledFields.includes(field.apiName) ?
                                        <div>
                                            <label className="text-white col-sm-5 col-12 m-0 py-2">{field.name}</label>
                                            <div className="d-inline col-sm-7 col-12">{this.state.workOrder[field.apiName] ? this.state.workOrder[field.apiName] : '---'}</div>
                                        </div>

                                        :

                                        field.showWT && this.state.workOrder.Outcome__c !== 'Canceled' ?

                                        <div className={field.cField ? (this.state.workOrder[field.cField] === field.cValue 
                                        || (field.cValue && this.state.workOrder[field.cField] && this.state.workOrder[field.cField]?.includes(field.cValue))) 
                                        ? '' : 'd-none' : ''}>
                                            <label className="text-white col-sm-5 col-12 m-0 py-2">{field.name}</label>
                                            <div className="d-inline col-sm-7 col-12">{this.state.workOrder[field.apiName] ? this.state.workOrder[field.apiName] : '---'}</div>
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            );
                        })
                    }

                    {
                        this.state.showServiceInfo ?
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Service Case To-Do List:</label>
                            { 
                                this.state.ToDoListArray.length !== 0 ?
                                this.state.ToDoListArray.map((item, index) => (
                                    <div className="col-sm-7 col-12 py-2">    
                                        <li className="px-4" key={index} dangerouslySetInnerHTML={{__html: item}}></li>
                                    </div>))
                                :
                                ''
                            }
                        </div>
                        :
                        null
                    }
                </div>
            }

            {/* Footer of Field Job Form that includs the buttons for Endind and Saving Job */}
            <div className="mt-5 mb-4">
                <div className={this.state.workOrder.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.saveFields('end')}>End Job</button>
                </div>

                <div className={this.state.workOrder.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.saveFields('end')}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.workOrderId ? `/workOrders/${this.workOrderId}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" disabled={this.state.disableSave} onClick={() => this.saveFields('save')}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.state.workOrder.Jobsite_Photos__c ? this.state.workOrder.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                    </div>

                </div>
            </div>

            {/* ---------- Cancel Pending Modal: ---------- */}
            <Modal
                isOpen={this.state.shouldShowTooltip}
                onRequestClose={() => this.setState({
                    shouldShowTooltip: false
                })}
                className="ReactModal"
                overlayClassName="ReactModal__Overlay"
                style={{
                    overlay: {
                        backgroundColor: 'rgba(255, 255, 255, 0.75)'
                    },
                    content: {
                        background: 'rgba(53, 53, 53)',
                    }
                }}
            >
                <div className="d-flex justify-content-between text-white">
                    <h3>{this.state.tooltipTitle}</h3>
                    <span className="mx-2 cursor-pointer">
                        <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({
                            shouldShowTooltip: false
                        })} />
                    </span>
                </div>

                <div className="mt-3 text-white">
                    <p dangerouslySetInnerHTML={{__html: this.state.tooltipBody}}></p>
                </div>

                <div className="mt-3 text-right text-white">
                    <button className="btn btn-primary" type="button" disabled={this.state.disableCancelPending} onClick={() => this.setState({shouldShowTooltip: false})}>Close</button>
                </div>
            </Modal>

        </div>
    );} else {
        return(
            <div className='text-white text-center'>
                <div className={css.FieldJobForms__Loader}></div>
                <h2 className='pt-3'>Loading</h2>
            </div>
        );}
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(WorkOrderForm);
